import { render, staticRenderFns } from "./CadastroModal.vue?vue&type=template&id=6c847af2"
import script from "./CadastroModal.vue?vue&type=script&lang=js"
export * from "./CadastroModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports